export const formatPrice = (num?: number) => {
  return (num ?? 0).toLocaleString('USD', {
    style: 'currency',
    currency: 'GBP',
  });
};
